// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".button.is-current[data-v-ed6b31f6]{background-color:#5e95c8;color:#fff;border-color:transparent}.button.is-current[data-v-ed6b31f6]:disabled{opacity:1}", ""]);
// Exports
module.exports = exports;
